import AssetUpload from 'components/AssetUpload';
import LibraryContentUpload from 'components/LibraryContentUpload';
import { Form, Input, Modal, Select } from 'antd';
import { IDocument } from 'interfaces/libraries';
import { useForm } from '@refinedev/antd';
import { useModalReturnType } from '@refinedev/core';

interface CreateDocumentModalProps {
  modal: useModalReturnType;
  libraryId: string;
  onFinish?: () => void;
}

const CreateDocumentModal = ({
  modal,
  libraryId,
  onFinish
}: CreateDocumentModalProps) => {
  const onClose = () => {
    modal.close();
  };

  const { form, formProps } = useForm<IDocument>({
    resource: 'prometheus/v2/documents',
    onMutationSuccess: () => {
      modal.close();
      form.resetFields();
      onFinish?.();
    }
  });

  return (
    <Modal
      open={modal?.visible}
      title="Criar Documento"
      onCancel={onClose}
      onOk={form.submit}
    >
      <Form
        {...formProps}
        initialValues={{ library_id: libraryId }}
        layout="vertical"
      >
        <Form.Item name="library_id" hidden>
          <Input type="hidden" value={libraryId} />
        </Form.Item>
        <Form.Item
          label="Nome"
          name="name"
          rules={[{ required: true, message: 'Nome é obrigatório' }]}
        >
          <Input placeholder="Nome" />
        </Form.Item>
        <Form.Item label="Thumbnail" name="thumbnail_url">
          <AssetUpload accept="image/*" type="thumbnail" />
        </Form.Item>
        <Form.Item label="Autores" name="authors">
          <Select mode="tags" />
        </Form.Item>
        <Form.Item
          label="Arquivo"
          name="source_url"
          rules={[{ required: true, message: 'Arquivo é obrigatório' }]}
        >
          <LibraryContentUpload type="document" accept="application/pdf" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateDocumentModal;
